/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import { ClaimDetailsSVG, CoverageSVG } from '../../../img/GlobalSVG';
import moment from 'moment';
import useDate from '../../../utils/useDate';
import ClaimDetailsSkeleton from './skeleton/ClaimDetailsSkeleton';
import { axiosInstance } from 'src/api/axios';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import ButtonWithMenu from '../../common/ButtonWithMenu';
import { maskedSSN } from 'src/common/masking';
import { ErrorCircle, SuccessCircle } from '../../../img/findcare/FindCareSVG';
import { t } from 'i18next';
import MasterPermissions from '../../../api/MasterPermissions';
import './detail.scss';
import APIEndpoints from '../../../api/APIEndpoints';
import FilterModal from '../../common/filter-modal/FilterModal';
import { Link } from 'react-router-dom';
import { IconSVG } from 'src/Admin/img/uploadDocument/uploadDocumentSVG';
import { toast } from 'react-toastify';
import ToastMessage from '../../common/ToastMessage';
import Httpheader from 'src/Admin/shared/httpheader';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});
const InNetworkChip = ({ variant }) => {
  return (
    <button disabled className={`in-network-${variant} d-block mt-2 mb-2`}>
      <div className="d-flex align-items-center">
        {variant === 'success' && <SuccessCircle className="success-circle" />}
        {variant === 'danger' && <ErrorCircle className="danger-circle" />}
        <span>
          {variant === 'success'
            ? t('find_provider.in_network')
            : t('find_provider.out_of_network')}
        </span>
      </div>
    </button>
  );
};

const Panels = ({
  dataFetching,
  claimDetailsResp,
  networkName,
  getJVCoreStatusFromConfig,
  claimsLabelConfiguration,
  overlay,
  otherDiagnosisCode,
  oid,
  memberType,
}) => {
  const cName = Httpheader.getCNAME();
  const { Display_Network_Tier_Claim_Details } =
    useSelector((state) => state.app.appConfigs.Network_Setting) || 'true';
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { formatDate } = useDate();
  const [description, setDiscription] = useState();
  const download_buttons = [];
  MasterPermissions.CheckPermission('Download EOB') &&
    download_buttons.push({ label: 'DOWNLOAD EOB', value: 'EOB' });
  MasterPermissions.CheckPermission('Download EOP') &&
    (cName.includes('mybenefits') || cName.includes('roundstone')) &&
    download_buttons.push({ label: 'DOWNLOAD EOP', value: 'CHK' });

  //const [isDownloadEOBFailed, setIsDownloadEOBFailed] = useState(false);
  //const [isDownloadEOPFailed, setIsDownloadEOPFailed] = useState(false);
  const [isOpenColumnsPopup, setIsOpenColumnsPopup] = useState(false);
  const [isEOBEOP, setIsEOBEOP] = useState('EOB');
  const downloadEOB = async (claimNumber, value) => {
    try {
      setIsEOBEOP(value === 'EOB' ? 'EOB' : 'EOP');
      const EobUrl =
        cName.includes('keenan') || cName.includes('tpabenefits')
          ? `${APIEndpoints.getEOB()}${claimNumber}`
          : `${APIEndpoints.getEchoEOB()}${claimNumber}/DocType/${value}`;

      const documentData = await axiosInstance.get(EobUrl, {
        responseType: 'arraybuffer',
      });
      if (documentData?.data?.byteLength < 10000 || documentData?.data === '') {
        toast.error(
          <ToastMessage
            type="error"
            title="Error!"
            subTitle={`No ${
              value === 'EOB' ? 'EOB' : 'EOP'
            } found for this Claim. Please contact
        your Administrator for further information.`}
          />,
        );
        //if (value === 'EOB') {
        //setIsDownloadEOBFailed(true);
        //} else {
        //setIsDownloadEOPFailed(true);
        //}
      } else {
        const fileURL = window.URL.createObjectURL(
          new Blob([documentData.data]),
        );
        const downloadEOBLink = document.createElement('a');
        downloadEOBLink.href = fileURL;
        downloadEOBLink.download = `${
          value === 'EOB' ? 'EOB' : 'EOP'
        }-${claimNumber}.pdf`;
        document.body.appendChild(downloadEOBLink);
        downloadEOBLink.click();
        document.body.removeChild(downloadEOBLink);
      }
    } catch (error) {
      console.log(error);
      toast.error(
        <ToastMessage
          type="error"
          title="Error!"
          subTitle={`No ${
            value === 'EOB' ? 'EOB' : 'EOP'
          } found for this Claim. Please contact
      your Administrator for further information.`}
        />,
      );
      //if (value === 'EOB') {
      //setIsDownloadEOBFailed(true);
      //} else {
      //setIsDownloadEOPFailed(true);
      //}
    }
  };

  function convertUnitToDate(unitTimestamp) {
    const date = new Date(unitTimestamp);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }
  const showOtherDiagnosis = () => {
    setIsOpenColumnsPopup(true);
  };
  //Render the UI for your table
  return (
    <div className="clear">
      {dataFetching ? (
        <ClaimDetailsSkeleton />
      ) : (
        <>
          <Row className="claim-details-description ">
            {/*<div className="claim-details-description "> */}
            <Col className="claims-detail-container-align">
              <div>
                <div>
                  <h3 className="mb-1 patient-info">Patient Information</h3>
                  <div className="patient-details">
                    {claimDetailsResp?.Claim?.PatientName && (
                      <span className=" mb-1 mt-1">
                        Name:
                        <span className=" ml-1 patient-name">
                          {claimDetailsResp?.Claim?.PatientName}{' '}
                          <span className="member">
                            ({claimDetailsResp?.Claim?.UserType})
                          </span>
                        </span>
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.DateOfBirth && (
                      <span className="mb-1 mt-1 ">
                        DOB:
                        {
                          <span className="patient-details-bold ml-1">
                            {formatDate(claimDetailsResp?.Claim?.DateOfBirth)}
                          </span>
                        }
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.Gender && (
                      <span className="mb-1 mt-1 ">
                        Gender:
                        <span className="patient-details-bold ml-1">
                          {claimDetailsResp?.Claim?.Gender}
                        </span>
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.Certificate_Number && (
                      <span className="mb-1 mt-1 ">
                        Certificate Number:
                        <span className="patient-details-bold ml-1">
                          {claimDetailsResp?.Claim?.Certificate_Number}
                        </span>
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.Alternate_ID1 && (
                      <span className="mb-1 mt-1 ">
                        Alternate ID1:
                        <span className="patient-details-bold ml-1">
                          {claimDetailsResp?.Claim?.Alternate_ID1}
                        </span>
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.Alternate_ID2 && (
                      <span className="mb-1 mt-1 ">
                        Alternate ID2:
                        <span className="patient-details-bold ml-1">
                          {claimDetailsResp?.Claim?.Alternate_ID2}
                        </span>
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.SSN && (
                      <span className="mb-1 mt-1 ">
                        SSN:
                        {
                          <span className="patient-details-bold ml-1">
                            {maskedSSN(
                              Suppress_Setting?.SSN
                                ? Suppress_Setting?.SSN
                                : false,
                              claimDetailsResp?.Claim?.SSN,
                            )}
                          </span>
                        }
                      </span>
                    )}
                    {claimDetailsResp?.Claim?.Medical_Record_Number && (
                      <span className="mb-1 mt-1 ">
                        Medical Record:
                        <span className=" ml-1">
                          {claimDetailsResp?.Claim?.Medical_Record_Number}
                        </span>
                      </span>
                    )}
                  </div>
                </div>
                {(claimDetailsResp?.Claim?.ServicePhysician?.PhysicianName ||
                  claimDetailsResp?.Claim?.ServiceFacility?.FacilityName) && (
                  <div className="service-provider-name">
                    <div className="provider-label">Provider</div>
                    <div className="provider-name">
                      {claimDetailsResp?.Claim?.ServicePhysician
                        ?.PhysicianName != '' ? (
                        <Link
                          to={`/admin/claim-details/doctor-details/${claimDetailsResp?.Claim?.PhysicianID}`}
                          state={{
                            memberType: memberType,
                            memberOid: oid,
                            id: claimDetailsResp?.Claim?.FacilityID,
                          }}
                        >
                          {
                            claimDetailsResp?.Claim?.ServicePhysician
                              ?.PhysicianName
                          }
                        </Link>
                      ) : (
                        <Link
                          to={`/admin/claim-details/facility-details/${claimDetailsResp?.Claim?.FacilityID}`}
                          state={{
                            memberType: memberType,
                            memberOid: oid,
                            id: claimDetailsResp?.Claim?.FacilityID,
                          }}
                        >
                          {
                            claimDetailsResp?.Claim?.ServiceFacility
                              ?.FacilityName
                          }
                        </Link>
                      )}
                    </div>
                    <div className="patient-details">
                      {claimDetailsResp?.Claim?.ServicePhysician
                        ?.PhysicianName != '' ? (
                        <>
                          {MasterPermissions.CheckPermission(
                            'View Provider Tax ID',
                          ) &&
                            claimDetailsResp?.Claim?.Providertaxid && (
                              <span className="mb-1 mt-1 ">
                                Tax ID:
                                <span className=" ml-1">
                                  {claimDetailsResp?.Claim?.Providertaxid}
                                </span>
                              </span>
                            )}
                          {claimDetailsResp?.Claim?.ProviderNPID && (
                            <span className="mb-1 mt-1 ">
                              NPI ID:
                              <span className=" ml-1">
                                {claimDetailsResp?.Claim?.ProviderNPID}
                              </span>
                            </span>
                          )}
                        </>
                      ) : (
                        <>
                          {MasterPermissions.CheckPermission(
                            'View Provider Tax ID',
                          ) &&
                            claimDetailsResp?.Claim?.Providertaxid && (
                              <span className="mb-1 mt-1 ">
                                Tax ID:
                                <span className=" ml-1">
                                  {claimDetailsResp?.Claim?.Providertaxid}
                                </span>
                              </span>
                            )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                {/*<address>
                {claimDetailsResp?.Claim?.ServiceFacility?.FacilityName}
                {
                  claimDetailsResp?.Claim?.ServiceFacility?.FacilityAddress
                    ?.Address1
                }{' '}
                {claimDetailsResp?.Claim?.ServiceFacility?.FacilityAddress
                  ?.Address1 && <>{','} &nbsp;</>}
                {
                  claimDetailsResp?.Claim.ServiceFacility?.FacilityAddress
                    ?.Address2
                }{' '}
                {
                  claimDetailsResp?.Claim?.ServiceFacility?.FacilityAddress
                    ?.City
                }{' '}
                {claimDetailsResp?.Claim?.ServiceFacility?.FacilityAddress
                  ?.City && <>{','} &nbsp;</>}
                {
                  claimDetailsResp?.Claim?.ServiceFacility?.FacilityAddress
                    ?.State
                }{' '}
                &nbsp;
                {
                  claimDetailsResp?.Claim?.ServiceFacility?.FacilityAddress
                    ?.Zipcode
                }
                <span>
                  {' '}
                  Ph:{' '}
                  {claimDetailsResp?.Claim?.ServiceFacility?.PhoneNumber
                    ? claimDetailsResp?.Claim?.ServiceFacility?.PhoneNumber
                    : 'Not Available'}{' '}
                </span>
              </address> */}
              </div>
            </Col>
            <Col className="claims-detail-status-eob-container-align">
              <div>
                <h3 className="claim-details-description-name mb-1">
                  {t('member.pages.claims.claims_status')}&nbsp;
                  {claimDetailsResp?.Claim?.ClaimStatus}
                </h3>
                {claimDetailsResp?.Claim?.PaymentDate && (
                  <p className="claim-details-description-content-status">
                    {t('member.pages.claims.paid_on')}&nbsp;
                    {claimDetailsResp?.Claim?.PaymentDate == ''
                      ? ''
                      : formatDate(claimDetailsResp?.Claim?.PaymentDate)}
                  </p>
                )}
              </div>
              {(MasterPermissions.CheckPermission('Download EOB') ||
                MasterPermissions.CheckPermission('Download EOP')) && (
                <>
                  {getJVCoreStatusFromConfig(
                    claimDetailsResp?.Claim?.ClaimStatus.toLowerCase(),
                    claimsLabelConfiguration,
                  ) && (
                    <div className="claims-eob-eop">
                      {/*{!isDownloadEOBFailed && (
                        <ButtonWithMenu
                          variant="primary"
                          options={download_buttons}
                          title="DOWNLOAD EOB"
                          parentClassName="button-margin"
                          itemAction={(item) =>
                            downloadEOB(
                              claimDetailsResp?.Claim?.Claimnumber,
                              item?.value,
                            )
                          }
                          onClick={() => {
                            downloadEOB(
                              claimDetailsResp?.Claim?.Claimnumber,
                              download_buttons[0]?.value,
                            );
                          }}
                        >
                          <ClaimDetailsSVG.ClaimDetailDownloadSVG />
                          {t('member.pages.claims.download')}
                        </ButtonWithMenu>
                      )} */}
                      <div>
                        {download_buttons?.filter(
                          (item) => item?.label === 'DOWNLOAD EOB',
                        )?.length > 0 && (
                          <button
                            className="download-eob-or-eop mt-3"
                            role="button"
                            aria-label={`Click here to download Download EOB file`}
                            onClick={() => {
                              downloadEOB(
                                claimDetailsResp?.Claim?.Claimnumber,
                                'EOB',
                              );
                            }}
                            //disabled={isDownloadEOBFailed}
                          >
                            <IconSVG parentClassName="download-doc-icon" />
                            Download EOB
                          </button>
                        )}
                        {download_buttons?.filter(
                          (item) => item?.label === 'DOWNLOAD EOP',
                        )?.length > 0 && (
                          <button
                            className="download-eob-or-eop"
                            role="button"
                            aria-label={`Click here to download Download EOP file`}
                            onClick={() => {
                              downloadEOB(
                                claimDetailsResp?.Claim?.Claimnumber,
                                'CHK',
                              );
                            }}
                            //disabled={isDownloadEOPFailed}
                          >
                            <IconSVG parentClassName="download-doc-icon" />
                            Download EOP
                          </button>
                        )}
                      </div>
                      {/*{isDownloadEOBFailed && (
                        <p className=" claims-eob-desc mt-3  ">
                          No {isEOBEOP} found for this Claim. Please contact
                          your Administrator for further information.
                        </p>
                      )} */}
                    </div>
                  )}
                </>
              )}
              {claimDetailsResp?.Claim?.NetworkNameAndCode && (
                <span className=" mb-1 mt-1">
                  Network:
                  <span className="patient-details-bold ml-1">
                    {claimDetailsResp?.Claim?.NetworkNameAndCode}{' '}
                  </span>
                </span>
              )}
              {claimDetailsResp?.Claim?.BlkOfBusID && (
                <span className="mb-1 mt-1 ">
                  Block of Business:
                  <span className="patient-details-bold ml-1">
                    {' '}
                    {claimDetailsResp?.Claim?.BlkOfBusID}{' '}
                  </span>
                </span>
              )}
              {claimDetailsResp?.Claim?.ClientID && (
                <span className="mb-1 mt-1 ">
                  Client:
                  <span className="patient-details-bold ml-1">
                    {claimDetailsResp?.Claim?.ClientID}{' '}
                  </span>
                </span>
              )}
              {MasterPermissions.CheckPermission('View Diagnosis Code') && (
                <>
                  {claimDetailsResp?.Claim?.PrimaryDiagnosticCode && (
                    <span className="mb-1 mt-1 d-flex">
                      Primary Diagnostic Code:
                      <span className="tooltip-handcursor ml-1">
                        {overlay(
                          claimDetailsResp?.Claim?.PrimaryDiagnosticCode,
                          'ICD9 DIAGNOSIS',
                        )}
                      </span>
                    </span>
                  )}
                  {otherDiagnosisCode && otherDiagnosisCode.length > 1 && (
                    <span className="mb-1 mt-1 d-flex">
                      Other Diagnostic Code:
                      <span className="tooltip-handcursor-other-diagnosis ml-1">
                        {overlay(
                          otherDiagnosisCode[0]?.value,
                          'ICD9 DIAGNOSIS',
                        )}
                      </span>
                      {otherDiagnosisCode && otherDiagnosisCode.length > 1 && (
                        <span
                          className="tooltip-handcursor-other-diagnosis ml-1"
                          onClick={showOtherDiagnosis}
                        >
                          +{otherDiagnosisCode.length}
                        </span>
                      )}
                    </span>
                  )}
                </>
              )}
              {claimDetailsResp?.Claim?.CPGCode && (
                <span className="mb-1 mt-1 d-flex">
                  CPG Code:
                  <span className="tooltip-handcursor ml-1">
                    {overlay(claimDetailsResp?.Claim?.CPGCode, 'CPG CODE')}
                  </span>
                </span>
              )}
              {MasterPermissions.CheckPermission(
                'View Denied/Adjustment Reasons',
              ) && (
                <>
                  {claimDetailsResp?.Claim?.AdjustmentReasonCode && (
                    <span className="mb-1 mt-1 d-flex">
                      Adjustment Reasons:
                      <span className="tooltip-handcursor ml-1">
                        {overlay(
                          claimDetailsResp?.Claim?.AdjustmentReasonCode,
                          'Adjustment Reasons',
                        )}
                      </span>
                    </span>
                  )}
                </>
              )}
            </Col>
            <Col className="claims-detail-container-align">
              <div>
                <div>
                  <div className="claim-details-description-name display-normal mb-2">
                    {t('member.pages.claims.total_bill_amount')}
                  </div>
                  <div className="payment-value mb-2">
                    {claimDetailsResp?.Claim?.TotalCharge
                      ? formatter.format(claimDetailsResp?.Claim?.TotalCharge)
                      : '---'}
                  </div>
                </div>
                {/*{claimDetailsResp?.Claim?.SuppressPaymentInfo !== 'true' && ( */}
                {claimDetailsResp?.Claim?.DisplayPaymentInfo === 'true' && (
                  <div>
                    <div className="claim-details-description-name display-normal mb-2">
                      {t('member.pages.claims.patient_responsibility')}
                    </div>
                    {/*<span className="claim-details-price"> */}
                    <div className="payment-value mb-2">
                      {/*{
                    claimDetailsResp?.Claim?.SuppressPaymentInfo == 'true'
                    ? '---'
                    :
                    formatter.format(
                      claimDetailsResp?.Claim?.PatientResponsibility,
                    )
                  } */}
                      {claimDetailsResp?.Claim?.PatientResponsibility
                        ? formatter.format(
                            claimDetailsResp?.Claim?.PatientResponsibility,
                          )
                        : '---'}
                    </div>
                  </div>
                )}

                <div>
                  <div className="claim-details-description-name display-normal mb-2">
                    {t('member.pages.claims.amount_paid')}
                  </div>
                  <div className="payment-value mb-2">
                    {claimDetailsResp?.Claim?.TotalPaid
                      ? formatter.format(claimDetailsResp?.Claim?.TotalPaid)
                      : '---'}
                  </div>
                </div>
                {claimDetailsResp?.Claim?.BillType && (
                  <div>
                    <div className="claim-details-description-name display-normal mb-2">
                      Institutional Bill Type
                    </div>
                    <div className="payment-value mb-2">
                      {claimDetailsResp?.Claim?.BillType}
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <FilterModal
            titleLabel="Other Diagnostic Code(s)"
            isVisible={isOpenColumnsPopup}
            onHide={() => {
              setIsOpenColumnsPopup(false);
            }}
            showApply={false}
            showCancelLabel="Close"
            customClasses="show-hide-filter-options"
          >
            {otherDiagnosisCode &&
              otherDiagnosisCode.map((code) => {
                return (
                  <div className="other-codes" key={code?.value}>
                    <Col className="other-diagnosis-codes">
                      <span className="dia-label">{code?.key}</span>
                      <span className="dia-value d-flex">
                        Code: {overlay(code?.value, 'ICD9 DIAGNOSIS')}
                      </span>
                    </Col>
                  </div>
                );
              })}
          </FilterModal>
        </>
      )}
    </div>
  );
};

export default Panels;
